<!-- top section-->
<div class="pos-relative z-2 p-t-4 p-b-4 p-t-5-s p-b-5-s p-r-6 p-l-6 flex flex-justify-right flex-middle"
     style="box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);">
    <!-- hide button -->
    <i class="block icon-close col-11 fs-4 cursor-pointer right"
       (click)="hide()"></i>
</div>
<!-- content -->
<div class="w-12 pos-relative  shipping-methods flex"
     (offClick)="hide()"
     [offClickOff]="!isVisible"
     style="height: 100%;padding-bottom:4rem;">
    <basket-klarna-content-block class="w-12 wrap" />
</div>